module.exports = __webpack_public_path__ + "img/noel.780b10e4.jpg";